
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class DarkMatterEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(30 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2.5;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2.5;
                const drift = Math.sin(curTime * 0.1 + i) * 100;
                
                const r = (150 + this.pseudoRandom(i + 2) * 200) * scale * (1 / (layerIndex + 1));
                const grad = ctx.createRadialGradient(rx + drift, ry, 0, rx + drift, ry, r);
                grad.addColorStop(0, pc.color);
                grad.addColorStop(1, 'transparent');
                
                ctx.save();
                ctx.globalAlpha *= 0.1;
                ctx.fillStyle = grad;
                ctx.beginPath();
                ctx.arc(rx + drift, ry, r, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
